<template>
  <div class="app-container">
     <button class="back-button" @click="goBack">返回</button>
  
    <section class="hot-products">
      <h2>我的收藏</h2>
      <div v-if="hotProducts.length === 0" class="no-data">
        暂无收藏
      </div>
      <div class="product-list">
        <div
          class="product-item"
          v-for="(item, index) in hotProducts"
          :key="index"
        >
          <img :src="item.houseImageUrl" alt="Product Image" />
          <div class="product-title">{{ item.houseName }}</div>
          <button class="view-button" @click="goToDetail(item.houseId)">去查看</button>
        </div>
      </div>
    </section>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getCurrentInstance } from 'vue';
import {  ElMessage } from 'element-plus';


const { proxy } = getCurrentInstance();
const router = useRouter();
const hotProducts = ref([]);

const isAdmin = ref('0');

const goToDetail = (productId) => {
  router.push({ name: 'HouseDetail', params: { houseId: productId } });
};

const fetchImages = async () => {
  const url = '/home/queryLikeHouse';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if (response.data.rspHead.returnCode === '00000000') {
      hotProducts.value = response.data.rspBody.houseList;
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员');
  }
};

const checkRule = async () => {
  const url = '/login/checkRule';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if (response.data.rspHead.returnCode === '00000000') {
      isAdmin.value = response.data.rspBody.isAdmin;
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员');
  }
};


const checkLogin = () => {
      let token = localStorage.getItem("token"); // 从缓存中获取token
        token = token || null;
      if (token) {
        // 如果有token，调用后端接口验证
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("0" === status) {
              router.push("/appLogin");
            } 
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
      
      // 这里可以添加查看施工图的逻辑
    };

    const goBack = () => {
  router.back();
};
onMounted(() => {
  checkLogin();
  fetchImages();
  checkRule();
});

</script>

<style scoped>
:root {
  /* --primary-color: #007bff; */
  /* --text-color: #666; */
  /* --active-text-color: #007bff; */
  /* --bg-blur: rgba(255, 255, 255, 0.98); */
  --transition-duration: 0.2s;
}

.app-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}

.back-button {
  position: fixed;
  top: 20px;
  left: 20px;
  padding: 8px 12px;
  background-color: transparent;
  border: 1px solid #007bff;
  border-radius: 4px;
  color: #007bff;
  cursor: pointer;
  z-index: 1000;
  font-size: 14px;
}

.back-button:hover {
  background-color: rgba(0, 123, 255, 0.1);
}




.hot-products {
  padding-bottom: calc(72px + env(safe-area-inset-bottom)); /* 动态计算安全区域 */
}

.hot-products h2 {
  background: rgba(255, 255, 255, 0.98);;
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 12px;
  color: #666;
  margin: 20px 0;
}

.product-list {
  display: grid;
  gap: 16px;
}

.product-item {
  background: rgba(255, 255, 255, 0.98);;
  backdrop-filter: blur(10px);
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 16px;
  transition: all var(--transition-duration) ease;
}

.product-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.product-item img {
  width: 100%;
  height: auto;
  aspect-ratio: 4/3;
  border-radius: 8px;
}

.product-title {
  font-size: 16px;
  color: #666;
  margin: 8px 0;
}

.product-buydetail {
  color: #ebcc04;
  font-size: 14px;
}

.view-button {
  background: transparent;
  border: 1px solid #007bff;
  color: #007bff;
  padding: 8px 16px;
  border-radius: 20px;
  margin-top: 12px;
  background: rgba(0,123,255,0.1);
  transition: all var(--transition-duration) ease;
}

.view-button:hover {
  background: rgba(0,123,255,0.1);
}


@media (max-width: 600px) {
  .app-container {
    padding: 10px;
  }

  .logoImg {
    width: 5vh;
    height: 4vh;
  }

  .header {
    padding: 12px;
  }

  .banner {
    border-radius: 8px;
  }

  .product-item {
    padding: 12px;
  }

}
</style>
